import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-notification-mode-dialog',
  templateUrl: './notification-mode-dialog.component.html',
  styleUrls: ['./notification-mode-dialog.component.scss']
})
export class NotificationModeDialogComponent implements OnInit {
  primaryColour: string = '#2196F3';

  constructor(
    public dialogRef: MatDialogRef<NotificationModeDialogComponent>
  ) { }

  ngOnInit() {
    this.primaryColour = localStorage.getItem('primaryColour') || '#2196F3';
  }

  selectMode(mode: number) {
    let result = {
      mode: mode,
      descriptionContent: mode == 3,
      fileContent: mode == 2 || mode == 3
    }
    this.dialogRef.close(result);
  }
}
